import { actionTypes } from '../../../types';

export const updateUserInfo = (payload, callback) => ({
    type: actionTypes.UPDATE_USER_INFO_REQUEST,
    payload,
    callback,
});

export const updateUserInfoSuccess = (payload) => ({
    type: actionTypes.UPDATE_USER_INFO_SUCCESS,
    payload,
});

export const updateUserInfoFailure = (payload) => ({
    type: actionTypes.UPDATE_USER_INFO_FAILURE,
    payload,
});

export const updateUserInfoReset = () => ({
    type: actionTypes.UPDATE_USER_INFO_RESET,
});
